import { ForwardedRef, forwardRef, HTMLProps, ReactNode } from "react";
import { ReactComponent as Search } from "assets/search.svg";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";
interface InputProps extends HTMLProps<HTMLInputElement> {
  label: string;
  error?: string;
  icon?: "search";
}

interface Icons {
  [key: string]: ReactNode;
}

const ICONS: Icons = {
  search: (
    <Search className="absolute ml-4 stroke-secondary-50 translate-y-[-50%] top-[50%]" />
  ),
};

export const cn = (...args: unknown[]) => {
  return twMerge(classNames(args));
};

const InputPlain = (
  { label, icon, className, error, ...inputAttributes }: InputProps,
  ref: ForwardedRef<HTMLInputElement>
) => (
  <label
    className={classNames("font-normal text-sm", {
      "text-red-700": !!error,
    })}
  >
    {label}
    <div className="h-full">
      {icon && ICONS[icon]}
      <input
        ref={ref}
        className={cn(
          "block w-full py-2.5 px-4 h-full text-sm text-primary-100 rounded border border-primary-10 focus:border-secondary-40 ",
          className,
          {
            "text-red-900 placeholder-red-700 bg-red-50 focus:border-red-500 border-red-500":
              !!error,

            "pl-12": !!icon,
          }
        )}
        {...inputAttributes}
      />
    </div>

    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </label>
);

export const Input = forwardRef(InputPlain);
